import { render, staticRenderFns } from "./Packlists.vue?vue&type=template&id=127c02d6&scoped=true"
import script from "./Packlists.vue?vue&type=script&lang=js"
export * from "./Packlists.vue?vue&type=script&lang=js"
import style0 from "./Packlists.vue?vue&type=style&index=0&id=127c02d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c02d6",
  null
  
)

export default component.exports